const KEYS = {
	customerId: 'swift_customer_id',
	leadId: 'swift_lead_id',
	sessionId: 'swift_session_id',
} as const;

function buildKey(base: string, prefix?: string): string {
	return prefix ? `${prefix}_${base}` : base;
}

export function getCustomerId(prefix?: string): string | null {
	return localStorage.getItem(buildKey(KEYS.customerId, prefix));
}

export function setCustomerId(id: string, prefix?: string): void {
	localStorage.setItem(buildKey(KEYS.customerId, prefix), id);
}

export function getLeadId(prefix?: string): string | null {
	return localStorage.getItem(buildKey(KEYS.leadId, prefix));
}

export function setLeadId(id: string, prefix?: string): void {
	localStorage.setItem(buildKey(KEYS.leadId, prefix), id);
}

export function getSessionId(prefix?: string): string | null {
	return localStorage.getItem(buildKey(KEYS.sessionId, prefix));
}

export function setSessionId(id: string, prefix?: string): void {
	localStorage.setItem(buildKey(KEYS.sessionId, prefix), id);
}
